import { supabase } from '@/lib/supabase'

// Builds the webcal:// URL that Apple Calendar / Google Calendar / Outlook
// accept as a subscription. We swap the scheme so tapping the link on iOS
// launches Calendar.app directly ("Add subscription").
export function buildFeedUrl(token: string, scheme: 'webcal' | 'https' = 'webcal'): string {
  const base = import.meta.env.VITE_SUPABASE_URL as string
  const host = base.replace(/^https?:\/\//, '')
  const prefix = scheme === 'webcal' ? 'webcal://' : 'https://'
  return `${prefix}${host}/functions/v1/ical-feed?token=${token}`
}

export async function ensureIcalToken(tourId: string): Promise<string> {
  const { data, error } = await supabase.rpc('ensure_my_ical_token', { p_tour: tourId })
  if (error) throw error
  if (typeof data !== 'string') throw new Error('Unexpected response from ensure_my_ical_token')
  return data
}

export async function regenerateIcalToken(tourId: string): Promise<string> {
  const { data, error } = await supabase.rpc('regenerate_my_ical_token', { p_tour: tourId })
  if (error) throw error
  if (typeof data !== 'string') throw new Error('Unexpected response from regenerate_my_ical_token')
  return data
}
